import React from 'react'
import styled, { css } from 'styled-components'
import { FooterLogo } from '../_svgs/FooterLogo/FooterLogo'
import { Phone } from '../_svgs/Phone/Phone'
import { IconEmailNewsletter } from '../_svgs/EmailNewsletter/EmailNewsletter'

export const FooterMainSection = () => {
  return (
    <FooterMainRow>
      <FooterMainContainer>
        <FooterLogoContainer id='sticky-footer-logo'>
          <LogoA
            href='/'
            className='bypassInterstitialPage swanson-logo-tracking'
            data-tracking='footer|swanson-logo'
            aria-label='Go to Swanson Health Home Page'
          >
            <FooterLogo
              labelColor='#fff'
              styles={css`
                @media (min-width: 1280px) {
                  height: auto;
                  width: 230px;
                }
                @media (max-width: 1279px) {
                  height: auto;
                  width: 170px;
                }
              `}
            />
          </LogoA>
        </FooterLogoContainer>
        <FooterMainLink>
          <FooterMainA
            href='tel:1-800-824-4491'
            aria-label='call 1-800-824-4491'
          >
            <Phone
              color='#fff'
              width='20px'
              height='20px'
              styles={css`
                margin-right: 8px;
              `}
            />
            <span>1-800-824-4491</span>
          </FooterMainA>
        </FooterMainLink>
        <FooterMainLink>
          <FooterMainA
            data-tracking='footer|help-dropdown|email'
            href='mailto:customercare@swansonsupport.com'
            aria-label='Email'
          >
            <IconEmailNewsletter
              styles={css`
                margin-right: 5px;
              `}
            />
            <span>Email Customer Care</span>
          </FooterMainA>
        </FooterMainLink>
      </FooterMainContainer>
    </FooterMainRow>
  )
}

const FooterMainRow = styled.div`
  background-color: ${(props) => props.theme.darkGreen};
  display: flex;
  align-items: center;
  @media (min-width: 768px) {
    border-bottom: 1px solid rgba(217, 217, 217, 0.5);
  }
`

const FooterMainContainer = styled.div`
  display: flex;
  align-items: center;
  max-width: 1420px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  padding-bottom: 18px;
  padding-top: 18px;
  @media (max-width: 1420px) {
    padding-left: 15px;
    padding-right: 15px;
  }
  @media (max-width: 767px) {
    flex-direction: column;
    padding-bottom: 30px;
    padding-top: 15px;
    gap: 15px;
  }
`

const FooterLogoContainer = styled.div`
  display: flex;
  align-items: center;
`

const LogoA = styled.a`
  display: flex;
  margin-bottom: 10px;
  line-height: 1;
  @media (min-width: 768px) {
    padding-right: 30px;
  }
  @media (max-width: 767px) {
    margin-bottom: 5px;
  }
`

const FooterMainLink = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  @media (min-width: 768px) {
    padding-left: 20px;
    padding-right: 20px;
    border-left: 1px solid rgba(217, 217, 217, 0.5);
  }
  @media (min-width: 1024px) {
    padding-left: 40px;
    padding-right: 40px;
  }
  @media (max-width: 767px) {
    width: 100%;
    max-width: 400px;
  }
`

const FooterMainA = styled.a`
  display: flex;
  align-items: center;
  font-size: 22px;
  color: ${(props) => props.theme.white} !important;
  text-decoration: none !important;
  transition: color 0.15s ease-in-out;
  &:hover {
    color: ${(props) => props.theme.white} !important;
    text-decoration-thickness: 1px !important;
    text-underline-offset: 3px;
    text-decoration: underline !important;
  }
  @media (max-width: 767px) {
    justify-content: center;
    background-color: rgba(255, 255, 255, .075);
    border-radius: 6px;
    font-size: 18px;
    line-height: 1;
    padding: 15px;
    width: 100%;
  }
`

const IconAt = styled.span`
  font-weight: 700;
  margin-right: 8px;
`
